// extracted by mini-css-extract-plugin
export default {"root":"styles_root__WzSyd","box":"styles_box__19rx+"};